import bbbLogo from '@perpay-web/components/assets/images/bbb.png';
import BackButton from '@perpay-web/components/base/BackButton/BackButton';
import mastercardLogo from '@perpay-web/fintech/assets/images/mastercardLogo.png';
import { useTransparentStatusBar } from '@perpay-web/fintech/hooks/useTransparentStatusBar';
import { getPartnerOnboardingLogo } from '@perpay-web/fintech/utils/partnerOnboardingUtils';
import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './CardApplicationHeader.scss';

const BBB_PARTNER_CLASSES = [
    'experian',
    'mastercard',
    'perpay-website',
    'google-search-ads',
    'influencer-promotion',
    'perpay-direct-mail',
    'out-of-home',
    'monevo',
    'monevo-ita',
];

const CardApplicationHeader = ({
    className = '',
    partnerCode,
    onBackClicked,
}) => {
    useTransparentStatusBar();
    const { partnerLogo, partnerLogoClassName } =
        getPartnerOnboardingLogo(partnerCode);

    const showBBBLogo =
        BBB_PARTNER_CLASSES.includes(partnerLogoClassName) || !partnerCode;

    return (
        <div className={getClassName(styles.header, className)}>
            <div className={styles.header__content}>
                {onBackClicked ? (
                    <BackButton
                        onClick={onBackClicked}
                        className={styles['back-button']}
                    />
                ) : null}
                <div className={styles.container}>
                    {showBBBLogo ? (
                        <div className={styles['perpay-logo--left']} />
                    ) : (
                        <img
                            src={partnerLogo}
                            alt='Partner Logo'
                            className={styles[partnerLogoClassName]}
                        />
                    )}
                    <div className={styles.container__divider} />
                    <img
                        src={mastercardLogo}
                        alt='Mastercard Logo'
                        className={styles.container__logo}
                    />
                    <div className={styles.container__divider} />
                    {showBBBLogo ? (
                        <img
                            src={bbbLogo}
                            alt='Better Business Bureau Logo'
                            className={styles['better-business-bureau']}
                        />
                    ) : (
                        <div className={styles['perpay-logo']} />
                    )}
                </div>
            </div>
        </div>
    );
};

export default CardApplicationHeader;
